import React, { useCallback, useState } from 'react'
import Autocomplete from 'react-autocomplete'
import './input.css'

function Input({renderText=()=>{}, label, name, placeholder, value, onChange, autocompleteFunc, onBlur=()=>{} ,onSelect=()=>{}, invalid=false, invalidText=""}) {
    const [items, setItems] = useState([])  
    const [selected, setSelected] = useState(null)      
    const changeValue = useCallback(
      (newValue) => {
        
        onChange(newValue)
        if (newValue.length>=3){
          autocompleteFunc(newValue)
          .then((response)=>{
            setItems(response.data)
          })
        }
      },
      [onChange, setItems, autocompleteFunc],
    );
    return (
      <div>
        <div className={"input-field "+ (invalid?"invalid":"")}>
          <label for={name}>
            {label}
          </label>
          {autocompleteFunc ? (
            <Autocomplete 
              items={items} 
              value={value}
              renderText={renderText}
              getItemValue={(item) => String(item.id)}
              renderItem={(item, isHighlighted) =>
                <div key={item.id} style={{ background: isHighlighted ? 'lightgray' : 'white' }} className="autocomplete-input">
                  {renderText(item)}
                </div>
              }
              onSelect={(val) => {                
                const element = items.find ((e)=> e.id == val)                
                onChange(renderText(element) )
                setSelected(element)
                onSelect(element)
              }}
              wrapperProps={{
                onFocus:(ev)=>{
                  ev.target.select()
                }
              }}
              onChange={(e) => changeValue(e.target.value)}
            />
          ):(
            <input name={name} placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)} onBlur={onBlur}/>
          )}
          
          
        </div>
        {invalid? (
            <div className="invalidText">
              {invalidText}
            </div>
          ):null}
      </div>
        
    )
}

export default Input